import {
  creatUUid,
  transformParamsToString,
  formatQueryToObject
} from "@/api/utils/api_helpers";
import Jsbridge from "@/jsbridge";
import { isEmpty, isIos } from "@/utils/lodash";
import {
  statusRes,
  INS_LOGIN_MSG,
  insLoginErrorResolve
} from "@/api/ins/base/ins_res_const";
import listenNative from "@/jsbridge/service/listenNative";

const FB_RIDIRECT_URL = "fb124024574287414://authorize/";
const HOST_NAME = "https://m.facebook.com";
const PATH = "/v2.8/dialog/oauth";
const PATH_2 = "/login.php";

const RES_URL_SUCCESS = `${FB_RIDIRECT_URL}#`;
const RES_URL_ERROR = `${FB_RIDIRECT_URL}?`;

const FB_E2E = () => {
  let time: string = (Math.random() * (86400 * 100) + 600).toString() + ".";
  for (let i = 0; i < 8; i++) {
    time += (Math.random() * 10).toString();
  }
  return JSON.stringify({
    init: time
  });
};

const FB_STATE = () => {
  const b5 = new Int32Array(5);
  b5[0] = Math.random() * 31 + 1;
  b5[1] = Math.random() * 31 + 1;
  b5[2] = Math.random() * 31 + 1;
  b5[3] = Math.random() * 31 + 1;
  b5[4] = Math.random() * 31 + 1;
  const ascii: any = new Int8Array(b5.buffer);
  const challenge: string = btoa(String.fromCharCode.apply(null, ascii));
  return JSON.stringify({
    challenge,
    "0_auth_logger_id": creatUUid(),
    "com.facebook.sdk_client_state": true,
    "3_method": "sfvc_auth"
  });
};

const FB_REQ_URL = () => {
  const BASE_URL = HOST_NAME + PATH;
  const BASE_URL_2 = HOST_NAME + PATH_2;
  const query = {
    auth_type: "rerequest",
    client_id: "124024574287414",
    default_audience: "friends",
    display: "touch",
    e2e: FB_E2E(),
    fbapp_pres: "0",
    local_client_id: "",
    redirect_uri: FB_RIDIRECT_URL,
    response_type: "token,signed_request",
    return_scopes: "true",
    scope: "email",
    sdk: "ios",
    sdk_version: "4.17.0",
    state: FB_STATE(),
    sfvc: "1"
  };
  const url = `${BASE_URL}?${transformParamsToString(query)}`;
  if (isIos()) {
    return url;
  }
  const url2_query = {
    skip_api_login: "1",
    api_key: "124024574287414",
    signed_next: "1",
    next: url
  };
  return `${BASE_URL_2}?${transformParamsToString(url2_query)}`;
  // return `${BASE_URL}?${transformParamsToString(query)}`;
};
export const listenBrowserClosed = async (
  browser_id: string,
  resolve: any,
  reject: any
) => {
  const listenId: string = await listenNative.addListen(
    `exit_${browser_id}`,
    (res: any) => {
      // remove listen:
      const { intercept_url } = res;
      const listen_res = intercept_url;

      listenNative.removeListen(listenId);

      console.log("listen_res:>>>", listen_res);

      if (isEmpty(listen_res) || typeof listen_res !== "string") {
        reject("User Cancle");
        return;
      }

      let paramsString: string = "";
      if (listen_res.includes(RES_URL_SUCCESS)) {
        paramsString = listen_res.substring(RES_URL_SUCCESS.length);
      } else if (listen_res.includes(RES_URL_ERROR)) {
        paramsString = listen_res.substring(RES_URL_ERROR.length);
      } else {
        reject("Oops, an error occurred.");
        return;
      }
      const params = formatQueryToObject(paramsString);

      if (params && params.access_token) {
        resolve(
          statusRes(INS_LOGIN_MSG.INS_LOGIN_SUCCESS, params.access_token)
        );
      } else {
        reject(insLoginErrorResolve(params));
      }
    }
  );
};
export const fb_login = () =>
  new Promise(async (resolve, reject) => {
    try {
      const browser_id: any = await Jsbridge.openBrowser(
        FB_REQ_URL(),
        "self_browser",
        {
          clear_cookie: true, // 避免用户需要切换fb登陆的账号
          intercept_element: FB_RIDIRECT_URL
        }
      );
      listenBrowserClosed(browser_id, resolve, reject);
    } catch (error) {
      reject(insLoginErrorResolve(error));
      console.log("fb_login error:", error);
    }
  });
